export default __webpack_public_path__ + "3a646851bdab45fdbd473df4870ed2aa.png";